import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { EnvironmentService } from '../../../app/services/environment.service';
import { ResponseBase } from '../../models/commonModels';
import { CarTypeListModel } from '../../models/car/carType';
import { MapMarkerResponseModel, MapAddressRequestModel } from '../../models/map/map';

@Injectable({
  providedIn: 'root'
})
export class MapService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }


public geocode() {
  const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');
  const options = { headers: httpHeaders };
  return this.httpClient.get<ResponseBase>(`${this.environmentService.getApiURL()}/map/garage/all`);

}

public getLocation(AddressRequest: MapAddressRequestModel) {
  const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');
  const options = { headers: httpHeaders };
  // const AddressRequest = new MapAddressRequestModel();
  // AddressRequest.Address = Address;
  return this.httpClient.post<MapMarkerResponseModel>(`${this.environmentService.getApiURL()}/map/get/location`, AddressRequest, options);

}

}
